import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LayersControl, FeatureGroup } from 'react-leaflet';

var LayersGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(LayersGroup, _Component);

  function LayersGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LayersGroup);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LayersGroup)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.render = function () {
      var _props = _this.props,
          id = _props.id,
          name = _props.name,
          checked = _props.checked,
          onBounds = _props.onBounds,
          zoomLevel = _props.zoomLevel,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['id', 'name', 'checked', 'onBounds', 'zoomLevel', 'children']);

      var childArray = React.Children.toArray(children);
      return React.createElement(LayersControl.Overlay, _extends({
        name: name,
        checked: checked
      }, props), React.createElement(FeatureGroup, {
        color: id
      }, React.Children.map((childArray || []).filter(function (ch) {
        return ch !== undefined && ch !== null && ch !== false;
      }), function (ch) {
        return React.cloneElement(ch, {
          onBounds: onBounds,
          zoomLevel: zoomLevel
        });
      })));
    }, _temp));
  }

  return LayersGroup;
}(Component);

LayersGroup.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool
};
LayersGroup.defaultProps = {
  checked: false
};
export default LayersGroup;